import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import './NotFound.less';

const NotFound = ({ onGoHome }) => {
	return (
		<div className="not-found">
			<div className="not-found-header">
				<div className="not-found-icon-wrapper">
					<ExclamationCircleOutlined className="not-found-icon" />
				</div>
				<h2 className="not-found-title">Page Not Found</h2>
				<p className="not-found-subtitle">
					The page you are looking for does not exist or has been moved.
				</p>
			</div>

			<div className="not-found-details-section">
				<div className="not-found-status-badge">
					<span>404 Error</span>
				</div>

				<div className="what-to-do-next">
					<h3 className="what-to-do-title">What should you do?</h3>
					<ul className="what-to-do-list">
						<li>• Check the URL for any typos</li>
						<li>• Return to the home page and start again</li>
						<li>• Contact support if you believe this is an error</li>
					</ul>
				</div>
			</div>

			<div className="go-home-button-section">
				<Button
					type="primary"
					size="large"
					block
					onClick={onGoHome}
					className="go-home-button"
				>
					Go to Home
				</Button>
			</div>
		</div>
	);
};

export default NotFound;
